import withTranslation from '../../../components/_hoc/withTranslation'

export default withTranslation
